import React, {useEffect} from 'react';
import {Route, Switch} from 'react-router-dom';
import {useDispatch} from "react-redux";
//Components
import PostsList from "./PostsList";
import CRUDPost from "./CRUDPost";
import {fetchPermissionsIfNeeded, invalidatePermissions} from "../../actions/PermissionActions";
import permissionReset from "../../reset/permissionReset";

export default function Posts() {

    const dispatch = useDispatch();
    //Effects
    useEffect(() => {
        dispatch(invalidatePermissions());
        dispatch(fetchPermissionsIfNeeded({show: "Mis permisos", module: "posts"}));
        return function cleanup() {
            permissionReset.resetAll(dispatch);
        }
    }, []);

    return (
        <Switch>
            <Route path="/posts/new" component={CRUDPost}/>
            <Route path="/posts/:idPost" component={CRUDPost}/>
            <Route path="/posts" component={PostsList}/>
            <Route path="/jobs/new" component={CRUDPost}/>
            <Route path="/jobs/:idPost" component={CRUDPost}/>
            <Route path="/jobs" component={PostsList}/>
        </Switch>

    );
}

